import axios from "axios";
const MockAdapter = require('axios-mock-adapter')
// const mock = new MockAdapter(axios) // This sets the mock adapter on the default instance
const mock = new MockAdapter(axios, { 
    onNoMatch: "passthrough" // Important pour permettre les requêtes non-mockées
  })

  // Ajouter une liste des routes à ne pas mocker (celles qui vont au backend réel)
const REAL_API_ROUTES = [
    '/api/send/mail'
  ];
  
  // Configurer mock pour ignorer les routes réelles
  REAL_API_ROUTES.forEach(route => {
    mock.onPost(route).passThrough();
  });
  
export default mock
